import CitySelect from '../components/city-select';

export default {
  init() {
    var that = this;
    this.county = ajax_args.county ? ajax_args.county : null;
    this.sector = ajax_args.sector ? ajax_args.sector : null;
    this.focus = ajax_args.focus ? ajax_args.focus : null;

    this.citySelect = new CitySelect({
      container: $('.c-city-select').first(),
      resultsContainer: $('.c-city-select__results').first(),
      loader: $('.c-city-select__loader').first(),
      input: $('.c-city-select__input').first(),
      onChange: function(value) {
        that.setCounty(value);
      },
      onReset: function() {
        that.setCounty(null);
      },
    });

    this.sectorSelectize = $('#c-consultans__sector-select').selectize({
      placeholder: $('#c-consultans__sector-select').attr('data-placeholder'),
      plugins: ['remove_button'],
    })[0].selectize;

    this.focusSelectize = $('#c-consultans__focus-select').selectize({
      placeholder: $('#c-consultans__focus-select').attr('data-placeholder'),
      plugins: ['remove_button'],
    })[0].selectize;

    if (this.county || this.sector || this.focus) {
      if (this.sector) {
        this.sectorSelectize.setValue(this.sector);
      }
      if (this.focus) {
        this.focusSelectize.setValue(this.focus);
      }
      if (this.county) {
        $('.c-consultants__map polygon[data-slug="' + this.county +'"]').addClass('active');
      }
      that.loadConsultants();
    }

    this.onResetClick = function(){
      that.county = null;
      that.citySelect.reset(false);
      that.sectorSelectize.clear();
      that.focusSelectize.clear();
      $('.c-consultants__map polygon').removeClass('active');
      $('.c-consultants__filtered-list__header').addClass('c-consultants__filtered-list__header--hidden');
      that.loadConsultants();
    };

    that.addEventHandlers();
  },
  setCounty(value) {
    this.county = value;

    $('.c-consultants__map polygon').removeClass('active');

    if (value) {
      $('.c-consultants__map polygon[data-slug="' + value +'"]').addClass('active');
    } else if (!this.sector) {
      $('.c-consultants__filtered-list__items').hide(0);
    }

    this.loadConsultants();
  },
  isLoading(loading) {
    if (loading) {
      $('.c-consultants__filtered-list').addClass('c-consultants__filtered-list--loading');
    } else {
      setTimeout(function(){
        $('.c-consultants__filtered-list').removeClass('c-consultants__filtered-list--loading');
      }, 333);
    }
  },
  loadConsultants() {
    const data = null;
    var that = this;

    this.isLoading(true);

    const sendData = Object.assign( {
      'dataType': 'json',
      'action': 'get_consultants',
      'county': this.county,
      'sector': this.sector,
      'focus' : this.focus,
    }, data);

    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: function (response) {
        that.isLoading(false);

        if (response != 0) {
          $('.c-consultants__filtered-list__items').html(response);
          $('.c-consultants__filtered-list__items').show(0);
          $('.c-consultants__filtered-list__placeholder').css('display', 'none');
          $('.c-consultants__filtered-list__header').removeClass('c-consultants__filtered-list__header--hidden');
          $('.c-consultants__reset-button').click(function(){
            that.onResetClick();
          });
        } else {
          $('.c-consultants__filtered-list__items').hide(0);
          $('.c-consultants__filtered-list__placeholder').css('display', 'block');
          $('.c-consultants__filtered-list__header').addClass('c-consultants__filtered-list__header--hidden');
        }

        that.updateEventhandlers();
      },
      error: function () {
        that.isLoading(false);
        that.updateEventhandlers();
        $('.c-consultants__filtered-list__items').hide(0);
        $('.c-consultants__filtered-list__placeholder').css('display', 'none');
      },
    });
  },
  addEventHandlers() {
    let that = this;

    // on sector select
    $('#c-consultans__sector-select').on('change', function() {
      that.sector = $('#c-consultans__sector-select').val();
      that.loadConsultants();
    });

    // on focus select
    $('#c-consultans__focus-select').on('change', function() {
      that.focus = $('#c-consultans__focus-select').val();
      that.loadConsultants();
    });

    // on county click
    $('.c-consultants__map polygon').click(function() {
      var value = null;
      let isActive = $(this).hasClass('active');
      $('.c-consultants__map polygon').removeClass('active');

      if (isActive == false) {
        $(this).addClass('active');
        value = $(this).attr('data-slug');
        that.citySelect.reset(false);
      }

      $('input[name="city"]').val($(this).attr('data-name'));


      that.setCounty(value);
    });

    // on county hover
    var mouseX; var mouseY;
    $(document).mousemove(function(e) { mouseX = e.pageX; mouseY = e.pageY; });
    $('.c-consultants__map polygon').mouseover(function() {
      $('.c-consultants__tooltip span').html($(this).attr('data-name'));
      $('.c-consultants__tooltip').stop(false, true).fadeIn(1);
      $(this).mousemove(function() {
        $('.c-consultants__tooltip').css({'top': mouseY-40, 'left': mouseX-150});
      });
    }).mouseout(function() {
      $('.c-consultants__tooltip').stop(false, true).fadeOut('slow');
    });

    // reset all button
    $('.c-consultants__reset-button').click(function(){
      that.onResetClick();
    });

    // switch view button action
    $('.c-consultants__switch-view-button').click(function(){
      that.toggleView();
    });
  },
  updateEventhandlers() {
    let that = this;
    $('.c-consultants__filter__nothing-found-button').click(function(){
      that.toggleView();
      that.onResetClick();
    });
  },
  toggleView() {
    if ($('#consultants-filtered').hasClass('active')) {
      $('#consultants-filtered').removeClass('active');
    } else {
      $('#consultants-filtered').addClass('active');
    }

    if ($('#consultants-all').hasClass('active')) {
      $('#consultants-all').removeClass('active');
    } else {
      $('#consultants-all').addClass('active');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/consultants.js